// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-client-temp-tsx": () => import("./../src/templates/client-temp.tsx" /* webpackChunkName: "component---src-templates-client-temp-tsx" */)
}

